import { Injectable } from '@angular/core';
import { ToastsManager, ToastOptions } from 'ng2-toastr/ng2-toastr';
import { Label } from '../../environments/resource';

export class CustomOption extends ToastOptions {
    animate = 'fade'; // you can override any options available
    newestOnTop = false;
    showCloseButton = true;
    positionClass = 'toast-top-center';
    toastLife = 10000;
    enableHTML = true;
}

// Serviço de notificações de mensagens
@Injectable()
export class NotificacaoService {


    constructor(private toastr: ToastsManager) { }

    public sucesso = (body: string, title = Label.sucesso, options?: any) => {
        return this.toastr.success(body, title, options);
    }

    public erro = (body: any, title = Label.ocorreuErro, options?: any) => {
        if (body && body.error && Array.isArray(body.error.message)) {
            body = body.error.message.join(', ');
        }
        return this.toastr.error(body, title, options);
    }

    public atencao = (body: string, title = Label.atencao, options?: any) => {
        return this.toastr.warning(body, title, options);
    }

    public info = (body: string, title = Label.ok, options?: any) => {
        return this.toastr.info(body, title, options);
    }

    public onClick = () => {
        return this.toastr.onClickToast();
    }
}



// WEBPACK FOOTER //
// /app/src/app/services/notificacao.service.ts